module.exports = __webpack_public_path__ + "static/media/chess.8e04fc0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DynamicContent/Main/About__block/chess.png
// module id = 318
// module chunks = 0